import iconDictionary from '../../../../utils/iconDictionary';

export const ICON_DICT = {
  info: iconDictionary('infoTooltipSIcon'),
  pending: iconDictionary('outlinedPendingPurple'),
  warning: iconDictionary('outlinedWarning'),
};
